import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOptionBtnByRouter } from "@/api/roleMenu/roleMenu";
import { resolveFileUrl } from "@/libs/fileUrl";
export default {
  props: {
    tableData: [Array],
    typeUser: [String],
    minWidth: [Number],
    columList: {
      default: function _default() {
        return [];
      }
    },
    sort: {
      default: function _default() {
        return [];
      }
    },
    options: {
      default: function _default() {
        return [];
      }
    },
    formatters: {
      default: function _default() {
        return {};
      }
    },
    isShowTrag: {
      default: function _default() {
        return false;
      }
    },
    isShowSelection: {
      default: function _default() {
        return false;
      }
    },
    pageNum: Number,
    pageSize: Number
  },
  data: function data() {
    return {
      newSort: this.sort
    };
  },
  mounted: function mounted() {
    this.rowDrop();
    this.getListBtn();
  },
  methods: {
    resolveFileUrl: resolveFileUrl,
    getListBtn: function getListBtn() {
      var _this = this;
      //type 3.列表按钮，4.操作项按钮
      if (this.options.length == 0) {
        var router = this.$route.path;
        getOptionBtnByRouter({
          router: router,
          type: 3
        }).then(function (res) {
          console.log('操作列表', res.data);
          res.data.forEach(function (item) {
            _this.options.push({
              name: item.name,
              class: item.router,
              option: item.component
            });
          });
        });
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    toggleSelection: function toggleSelection(rows) {
      var _this2 = this;
      if (rows) {
        rows.forEach(function (row) {
          _this2.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    returnFun: function returnFun(optionFun, row) {
      var result = null;
      this.$emit(optionFun, row, function (val) {
        result = val;
      });
      return result;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    sortChange: function sortChange(column) {
      this.newSort.order = column.order == null ? "" : column.order == "ascending" ? "asc" : "desc";
      this.newSort.prop = column.prop;
      this.$emit("sort:update", Object.assign({}, this.newSort));
      this.$emit("sortChange");
    },
    edit: function edit() {
      var v = this.$router.history.current.fullPath;
      this.$router.push(v + "/edit");
    },
    rowDrop: function rowDrop() {
      this.$emit("rowDrop");
    },
    bindClick: function bindClick(option, row, biaoji) {
      this.$emit(option, row, biaoji);
    },
    xbFormatter: function xbFormatter(value, prop) {
      if (Object.prototype.hasOwnProperty.call(this.formatters, prop)) {
        if (value == null || value.length == 0) {
          return "";
        }
        var strValue = value.toString().split(",");
        var returnResult = "";
        for (var j in strValue) {
          for (var k in this.formatters[prop]) {
            if (this.formatters[prop][k].value == strValue[j]) {
              returnResult += this.formatters[prop][k].name + " ";
            }
          }
        }
      }
      return returnResult;
    }
  }
};